import React, { useCallback } from 'react';
import Button from 'src/@vymo/ui/atoms/button';
import Text from 'src/@vymo/ui/atoms/text';
import { List, Popup } from 'src/@vymo/ui/blocks';
import { ReactComponent as Add } from 'src/assets/icons/add.svg';
import { ReactComponent as BuildingIcon } from 'src/assets/icons/building-line.svg';
import { ReactComponent as UserIcon } from 'src/assets/icons/user-line.svg';
import { LobSelectProp } from './types';
import styles from './index.module.scss';

interface HeaderProps {
  name: string;
  ctaLabel: string;
  onNewLobItemClick: (arg: LobSelectProp) => void;
  isCreateNewEnabled?: boolean;
  options: any;
}

function Header({
  name,
  ctaLabel,
  onNewLobItemClick,
  isCreateNewEnabled,
  options = [],
}: HeaderProps) {
  const getIcon = useCallback((applicationType) => {
    switch (applicationType) {
      case 'INDIVIDUAL':
        return <UserIcon />;
      case 'ENTITY':
        return <BuildingIcon />;
      default:
        return <UserIcon />;
    }
  }, []);
  return (
    <div className={styles.header}>
      <Text bold type="h3">{`Welcome, ${name}!`}</Text>
      {isCreateNewEnabled && options.length > 0 && (
        <Popup
          placement="bottom"
          closeTrigger="click"
          content={
            <List>
              {options.map((option) => (
                <List.Item
                  key={option.lob_code}
                  className={styles.header__popup__item}
                  onItemClick={() => {
                    if (!option.disabled) {
                      onNewLobItemClick({
                        entity: option.lob_code,
                        applicationType: option.application_type,
                      });
                    }
                  }}
                >
                  <Button
                    type="text"
                    iconProps={{
                      icon: getIcon(option.application_type),
                      iconPosition: 'left',
                    }}
                    disabled={option.disabled}
                  >
                    {option.name}
                  </Button>
                </List.Item>
              ))}
            </List>
          }
        >
          <Button
            variant="subtle"
            className={styles.header__cta}
            iconProps={{ icon: <Add />, iconPosition: 'right' }}
          >
            {ctaLabel}
          </Button>
        </Popup>
      )}
    </div>
  );
}

export default Header;
